import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/'
const ppi = '/api/p-std/'
const dpi = '/api/ps-docs/'
const fpi = '/api/ps-payments/'

export const StdStatistics = createAsyncThunk('std-statistics', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student/statistics`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const depStudents = createAsyncThunk('dep-students', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student/students`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ListStudent = createAsyncThunk('student-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student/list`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ListATAStudent = createAsyncThunk(
  'student-archive-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student/ata-list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const createStudent = createAsyncThunk('student-create', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}student/store`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const editStudent = createAsyncThunk('student-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getStudentDetails = createAsyncThunk(
  'student-details',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student/details/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const changeStudentStatus = createAsyncThunk(
  'change-student-status',
  async ({id, type}: {type: string; id: string}, thunkAPI) => {
    try {
      await axios.get(`${api}student/change-student-status/${id}/${type}`)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetTermClassByStudent = createAsyncThunk(
  'get-term-class-by-student',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student/get-term-class-by-student/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentClassMove = createAsyncThunk('move-student', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}student/move`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetStudentBySemester = createAsyncThunk(
  'student-by-semester',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/get-student-by-semester`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const PrintSemesterBookReport = createAsyncThunk(
  'print-semester-book',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/print-semester-book`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const SemesterBookStudentExcel = createAsyncThunk(
  'semester-book-students',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/excel-students-semester-book`, data, {
        responseType: 'blob',
      })

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'Semester Book Students.xlsx')
      document.body.appendChild(link)
      link.click()
      link.remove()
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const StudentCreditReport = createAsyncThunk(
  'student-credit-report',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/credit-report`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const PrintCreditReport = createAsyncThunk(
  'student-credit-report-print',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/credit-report-print`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ListStudentUpgrade = createAsyncThunk(
  'student-list-for-upgrade',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/list-upgrade`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentSemesterUpgrade = createAsyncThunk(
  'student-semester-upgrade',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/semester-upgrade`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ChangeStdPhoto = createAsyncThunk('change-photo', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}student/change-photo`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ChangeStdPassword = createAsyncThunk('change-password', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}student/change-password`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentCardPrint = createAsyncThunk('std-card-print', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student/print-card/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getStudentSemesters = createAsyncThunk(
  'student-semesters',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student/get-semesters/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getStudentSemesterScore = createAsyncThunk(
  'student-semester-score',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student/get-semester-score`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getStuSemesters = createAsyncThunk(
  'student-semesters',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student/get-stu-semesters/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getStuAttendance = createAsyncThunk(
  'student-attendance',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/get-stu-attendance`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getStdSemesters = createAsyncThunk('std-semesters', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}thesis/std-semseters/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetSemSubs = createAsyncThunk(
  'get-sem-subs',
  async ({semId, stdId}: {stdId: string; semId: string}, thunkAPI) => {
    try {
      const res = await axios.get(`${api}thesis/sem-subjects/${semId}/${stdId}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getSubLecturers = createAsyncThunk('get-sub-lecs', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}thesis/sub-lecturers/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const storeThesis = createAsyncThunk('store-thesis', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}thesis/store`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const stdTheses = createAsyncThunk('theses', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}thesis/list/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const editThesis = createAsyncThunk('thesis-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}thesis/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const approveThesis = createAsyncThunk('thesis-approve', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}thesis/approve/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const deleteThesis = createAsyncThunk('thesis-destroy', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}thesis/destroy/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetStudentGraduationBook = createAsyncThunk(
  'student-graduation-book',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/get-graduation-book`, data, {
        responseType: 'blob',
      })

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'Graduation Book.xlsx')
      document.body.appendChild(link)
      link.click()
      link.remove()
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const GetStudentGraduationBookPrint = createAsyncThunk(
  'student-graduation-book-print',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/print-graduation-book`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getStuTranscript = createAsyncThunk('thesis-destroy', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student/get-transcript/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getUpgradeSemesters = createAsyncThunk(
  'get-upgrade-semesters-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student/get-upgrade-semesters-list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const isShownSemesterBook = createAsyncThunk(
  'is-shown-semester-book',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/update-is-shown-semester-book`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const PrintStudents = createAsyncThunk('print-students', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student/print-students`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PrintStudentMarkSheet = createAsyncThunk(
  'print-student-mark-sheet',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student/print-student-mark-sheet`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ExcelStudentMarkSheet = createAsyncThunk(
  'student-mark-sheet-excel',
  async (params: {}) => {
    const response = await axios.get(`${api}student/excel-student-mark-sheet`, {
      params,
      responseType: 'blob',
    })

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })

    const url = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = 'Student Mark Sheet.xlsx'
    document.body.appendChild(link)
    link.click()

    link.remove()
    window.URL.revokeObjectURL(url)
  }
)

export const StudentExcel = createAsyncThunk('student-excel', async (params: {}) => {
  const response = await axios.get(`${api}student/excel-students`, {
    params,
    responseType: 'blob',
  })

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })

  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = 'Student List.xlsx'
  document.body.appendChild(link)
  link.click()

  link.remove()
  window.URL.revokeObjectURL(url)
})

export const StudentDocumentList = createAsyncThunk(
  'student-document-list',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student-document/list/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StoreDocument = createAsyncThunk(
  'student-document-store',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student-document/store`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const DeleteDocument = createAsyncThunk(
  'student-document-destroy',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student-document/destroy/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const DownloadDocument = createAsyncThunk(
  'documents/download',
  async (id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student-document/download/${id}`, {
        responseType: 'blob',
      })
      return response
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetStudentsForArchive = createAsyncThunk(
  'get-students-for-archive',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/get-students-for-archive`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ArchiveStudents = createAsyncThunk(
  'archive-students',
  async (formData: FormData, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/archive-students`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const transferStore = createAsyncThunk(
  'transfer-store',
  async (studentData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}student/transfer-store`, studentData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const StudentAlumniList = createAsyncThunk(
  'get-student-alumni-list',
  async (data: any, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/get-student-alumni-list`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentAlumniStore = createAsyncThunk('std-alu-store', async (data: any, thunkAPI) => {
  try {
    const response = await axios.post(`${api}student/get-student-alumni-store`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// previous student operations
export const ImPreStds = createAsyncThunk('import-std', async (data: any, thunkAPI) => {
  try {
    const response = await axios.post(`${ppi}import-std`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PreStds = createAsyncThunk('t-stds', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${ppi}t-stds/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const UpStdDetails = createAsyncThunk('update-std-details', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${ppi}update-std-details`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PphotoUpload = createAsyncThunk('t-upload-photo', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${ppi}t-upload-photo`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PreStdDetails = createAsyncThunk('t-std-details', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${ppi}t-std-details/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const CreatePreStd = createAsyncThunk('t-std-store', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${ppi}t-std-store`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const EditPrevStd = createAsyncThunk('t-std-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${ppi}t-std-edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PreTerms = createAsyncThunk('pre-terms', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${ppi}pre-terms`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PreClasses = createAsyncThunk('pre-cls', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${ppi}pre-cls/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// previous student documents
export const PreDocs = createAsyncThunk('docs', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${dpi}docs/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PreDocStore = createAsyncThunk('store', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${dpi}store`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PreDocDel = createAsyncThunk('delete', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${dpi}delete/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PrePayments = createAsyncThunk('payments', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${fpi}payments/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PrePaymentStore = createAsyncThunk('store', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${fpi}store`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PrePaymentEdt = createAsyncThunk('edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${fpi}edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PrePaymentDel = createAsyncThunk('delete', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${fpi}delete/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

type studentState = {
  errors: any
}

const initialState: studentState = {
  errors: '',
}

export const studentSlice = createSlice({
  name: 'student',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(transferStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = studentSlice.actions
export default studentSlice.reducer
